const upcUrl: Record<string, string> = {
  prod: 'https://partner.alta.avigilon.com',
  prodeu1: 'https://partner.eu.alta.avigilon.com',
  prodcan1: 'https://partner.can.alta.avigilon.com',
  prodaus1: 'https://partner.aus.alta.avigilon.com',
  dev: 'https://partner.dev.alta.avigilon.com',
  sandbox: 'https://partner.sandbox.alta.avigilon.com',
  mine: 'http://localhost:3000/partner',
  test: 'https://partner.test.alta.avigilon.com',
};

export const getUpcUrl = (region: OP.Env): string => {
  return `${upcUrl[region]}`;
};
